// Create/Edit form field configs per module path. Field names match the
// EXISTING backend request schemas exactly (IngredientIn/Update,
// SupplierCreateIn/SupplierUpdate, BuyerIn/BuyerUpdate).

const PRICE_TYPES = [
  { value: "STABLE", label: "Stable" },
  { value: "FLUCTUATING", label: "Fluctuating" },
  { value: "HIGHLY_FLUCTUATING", label: "Highly Fluctuating" },
  { value: "CONTRACT_FIXED", label: "Contract Fixed" },
];

const ingredientFields = [
  { name: "name", label: "Ingredient Name", type: "text", required: true, col: 2 },
  { name: "category", label: "Category", type: "select", optionsEndpoint: "/categories", optionValue: "name", optionLabel: "name" },
  { name: "brand", label: "Brand", type: "text" },
  { name: "unit", label: "Base Unit", type: "text", placeholder: "kg" },
  { name: "consumptionUnit", label: "Consumption Unit", type: "text" },
  { name: "packingSize", label: "Pack Size", type: "number" },
  { name: "packingUnit", label: "Pack Unit", type: "text", placeholder: "kg" },
  { name: "rate", label: "Rate (₹)", type: "number" },
  { name: "purchasePrice", label: "Purchase Price (₹)", type: "number" },
  { name: "gstPct", label: "GST %", type: "number" },
  { name: "priceType", label: "Price Type", type: "select", options: PRICE_TYPES },
  { name: "storageLocation", label: "Storage Location", type: "text" },
  { name: "minStock", label: "Min Stock", type: "number" },
  { name: "reorderLevel", label: "Reorder Level", type: "number" },
  { name: "maxStock", label: "Max Stock", type: "number" },
  { name: "batchTracking", label: "Batch Tracking", type: "checkbox" },
  { name: "expiryTracking", label: "Expiry Tracking", type: "checkbox" },
  { name: "active", label: "Active", type: "checkbox", default: true },
];

const supplierCreateFields = [
  { name: "name", label: "Supplier Name", type: "text", required: true, col: 2 },
  { name: "legalName", label: "Legal Name", type: "text", col: 2 },
  { name: "gstin", label: "GSTIN", type: "text" },
  { name: "fssai", label: "FSSAI No.", type: "text" },
  { name: "contactPerson", label: "Contact Person", type: "text" },
  { name: "mobile", label: "Mobile", type: "text" },
  { name: "email", label: "Email", type: "text" },
  { name: "paymentTerms", label: "Payment Terms", type: "text" },
  { name: "creditDays", label: "Credit Days", type: "number" },
  { name: "address", label: "Address", type: "textarea", col: 2 },
  { name: "city", label: "City", type: "text" },
  { name: "state", label: "State", type: "text" },
  { name: "pin", label: "PIN", type: "text" },
  { name: "openingBalance", label: "Opening Balance (₹ payable)", type: "number" },
  { name: "openingBalanceDate", label: "Opening Balance As-of Date", type: "text", placeholder: "YYYY-MM-DD" },
  { name: "approved", label: "Approved", type: "checkbox" },
];

const supplierEditFields = [
  { name: "name", label: "Supplier Name", type: "text", required: true, col: 2 },
  { name: "code", label: "Code", type: "text" },
  { name: "gstin", label: "GSTIN", type: "text" },
  { name: "contactPerson", label: "Contact Person", type: "text" },
  { name: "phone", label: "Phone", type: "text" },
  { name: "email", label: "Email", type: "text" },
  { name: "paymentTerms", label: "Payment Terms", type: "text" },
  { name: "leadTimeDays", label: "Lead Time (days)", type: "number" },
  { name: "address", label: "Address", type: "textarea", col: 2 },
  { name: "openingBalance", label: "Opening Balance (₹ payable)", type: "number" },
  { name: "openingBalanceDate", label: "Opening Balance As-of Date", type: "text", placeholder: "YYYY-MM-DD" },
  { name: "active", label: "Active", type: "checkbox", default: true },
];

const buyerFields = [
  { name: "parentCompany", label: "Parent Company / Legal Name", type: "parentCompany", required: true, col: 2, section: "Company" },
  { name: "company", label: "Trade Name (if different)", type: "text", col: 2, section: "Company" },
  { name: "name", label: "Store / Branch Name (e.g. KHARADI)", type: "text", required: true, col: 2, section: "Store / Branch" },
  { name: "storeCode", label: "Store Code", type: "text", section: "Store / Branch" },
  { name: "gstin", label: "GSTIN (branches may share the same GSTIN)", type: "text", section: "Tax" },
  { name: "pan", label: "PAN", type: "text", section: "Tax" },
  { name: "contactPerson", label: "Contact Person", type: "text", section: "Contact" },
  { name: "mobile", label: "Mobile", type: "text", section: "Contact" },
  { name: "email", label: "Email", type: "text", section: "Contact" },
  { name: "billingAddress", label: "Billing Address", type: "textarea", col: 2, section: "Address" },
  { name: "shippingAddress", label: "Shipping Address", type: "textarea", col: 2, section: "Address" },
  { name: "city", label: "City", type: "text", section: "Address" },
  { name: "state", label: "State", type: "text", section: "Address" },
  { name: "pincode", label: "Pincode", type: "text", section: "Address" },
  { name: "paymentTerms", label: "Payment Terms", type: "text", section: "Commercial" },
  { name: "paymentTermsDays", label: "Payment Terms (days) — for ageing due date", type: "number", section: "Commercial" },
  { name: "tdsApplicable", label: "TDS Applicable (buyer deducts TDS)", type: "checkbox", default: false, section: "Commercial" },
  { name: "tdsRate", label: "TDS Rate % (e.g. 0.01) — default only, editable per receipt", type: "number", section: "Commercial" },
  { name: "tdsSection", label: "TDS Section / Nature (optional)", type: "text", section: "Commercial" },
  { name: "creditDays", label: "Credit Days", type: "number", section: "Commercial" },
  { name: "preferredDelivery", label: "Preferred Delivery", type: "text", section: "Commercial" },
  { name: "specialInstructions", label: "Special Instructions", type: "textarea", col: 2, section: "Commercial" },
  { name: "active", label: "Active", type: "checkbox", default: true, section: "Commercial" },
];

const productFields = [
  { name: "name", label: "Product Name", type: "text", required: true, col: 2 },
  { name: "productType", label: "Classification (Bakery / Non-Bakery)", type: "select", required: true, options: [
    { value: "BAKERY", label: "Bakery" }, { value: "NON_BAKERY", label: "Non-Bakery" },
  ] },
  { name: "sku", label: "SKU", type: "text" },
  { name: "category", label: "Category", type: "text" },
  { name: "subcategory", label: "Sub-category", type: "text" },
  { name: "sellingPrice", label: "Selling Price (₹)", type: "number" },
  { name: "sellingPriceLocked", label: "Lock selling price (stop auto-update from sales bills)", type: "checkbox" },
  { name: "mrp", label: "MRP (₹)", type: "number" },
  { name: "costPrice", label: "Cost Price (₹)", type: "number" },
  { name: "standardYield", label: "Standard Yield", type: "number" },
  { name: "yieldUnit", label: "Yield Unit", type: "text", placeholder: "pcs" },
  { name: "piecesPerPack", label: "Pieces / Pack", type: "number" },
  { name: "packsPerCarton", label: "Packs / Carton", type: "number" },
  { name: "piecesPerCarton", label: "Pieces / Carton", type: "number" },
  { name: "cartonSize", label: "Carton Size", type: "text" },
  { name: "productUnit", label: "Product Unit", type: "text", placeholder: "pcs" },
  { name: "shelfLife", label: "Shelf Life", type: "text" },
  { name: "storageCondition", label: "Storage Condition", type: "text" },
  { name: "packagingSpec", label: "Packaging Spec", type: "textarea", col: 2 },
  { name: "active", label: "Active", type: "checkbox", default: true },
];

export const FORMS = {
  "/ingredients": { singular: "Ingredient", createFields: ingredientFields, editFields: ingredientFields },
  "/suppliers": { singular: "Supplier", createFields: supplierCreateFields, editFields: supplierEditFields },
  "/buyers": { singular: "Buyer", createFields: buyerFields, editFields: buyerFields },
  "/products": { singular: "Product", createFields: productFields, editFields: productFields },
};
